import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import type { RootState } from '@/app/store';
import { REACT_APP_ENVIRONMENT } from '@/config';
import { getSubdomain } from '@/utils';
// import ButtonLeftArrow from '@/assets/images/icon_arrow-left.svg';
// import ButtonRightArrow from '@/assets/images/icon_arrow-right.svg';

type Props = {
  title?: string;
};

const NO_INDEX_ENVIRONMENTS = ['debug', 'development', 'ita', 'local'];
const NO_INDEX_SUBDOMAINS = ['demo-toyonaka', 'uhuru', 'taiji-signage'];
/**
 * 当該ページを Google のインデックスから除外するか判定する
 * @returns boolean（メタタグを適用する場合は true）
 */
const shouldApplyNoIndex = (): boolean => {
  const subdomain = getSubdomain();

  return (
    NO_INDEX_ENVIRONMENTS.includes(REACT_APP_ENVIRONMENT) ||
    NO_INDEX_SUBDOMAINS.includes(subdomain)
  );
};

export const HeadBlock = ({ title }: Props) => {
  const { serviceProfile } = useSelector(
    (state: RootState) => state.serviceProfile
  );

  return (
    <Helmet>
      <title>
        {`${serviceProfile?.appName} | ${title ?? ''}` ??
          serviceProfile.appName}
      </title>
      {/* 条件を満たす場合 meta タグを適用 */}
      {shouldApplyNoIndex() && (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {/* <link rel="preload" as="image" href={ButtonLeftArrow} />
      <link rel="preload" as="image" href={ButtonRightArrow} /> */}
    </Helmet>
  );
};
